import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import user from './user/reducer';
import login from './login/reducer';
import home from './home/reducer';
import workShift from './workShift/reducer';
import attendance from './attendance/reducer';
import form from './form/reducer';
import snackbar from './snackbar/reducer';
import myApproval from './myApproval/reducer';
import delegatedRequest from './delegatedRequest/reducer';
import myRequest from './myRequest/reducer';
import inbox from './inbox/reducer';
import preOvertime from './preOvertime/reducer';
import impersonation from './impersonation/reducer';
import team from './team/reducer';
import overtimeVoluntary from './overtimeVoluntary/reducer';
import inactiveRequest from './inactiveRequest/reducer';

const reducers = combineReducers({
  menu,
  settings,
  user,
  login,
  home,
  workShift,
  attendance,
  form,
  snackbar,
  myApproval,
  delegatedRequest,
  myRequest,
  inbox,
  preOvertime,
  impersonation,
  team,
  overtimeVoluntary,
  inactiveRequest,
});

export default reducers;
